import React from "react";
import api from "../../infra/http/api";
import IconByName from "../../modules/solicitacoes/components/IconByName";
import { REQUEST_KINDS } from "./constants";
import SiteHeader from "./SiteHeader";

function groupForms(forms, term) {
  const q = term.trim().toLowerCase();
  const map = new Map();
  for (const f of forms) {
    if (q && !`${f.title} ${f.description} ${f.group}`.toLowerCase().includes(q)) continue;
    const g = f.group || "Outros";
    if (!map.has(g)) map.set(g, []);
    map.get(g).push(f);
  }
  return Array.from(map.entries()).sort(([a], [b]) =>
    a.localeCompare(b, "pt", { sensitivity: "base" }),
  );
}

export default function PublicRequestsPage({ kind }) {
  const [state, setState] = React.useState({ status: "loading", forms: [] });
  const [term, setTerm] = React.useState("");

  React.useEffect(() => {
    document.title = `${REQUEST_KINDS[kind].title} | SIMEMP`;
    let alive = true;
    api
      .get("/public/request-forms")
      .then(({ data }) => {
        if (!alive) return;
        const forms = Array.isArray(data?.[kind]) ? data[kind] : [];
        setState({ status: "ready", forms });
      })
      .catch(() => {
        if (alive) setState({ status: "error", forms: [] });
      });
    return () => {
      alive = false;
    };
  }, [kind]);

  const groups = React.useMemo(() => groupForms(state.forms, term), [state.forms, term]);

  return (
    <div className="ps-page">
      <SiteHeader>
        <nav className="ps-tabs" aria-label="Tipo de solicitação">
          {Object.entries(REQUEST_KINDS).map(([k, item]) => (
            <a
              key={k}
              href={item.path}
              className={`ps-tab${k === kind ? " ps-tab--active" : ""}`}
              aria-current={k === kind ? "page" : undefined}
            >
              {item.title}
            </a>
          ))}
        </nav>
      </SiteHeader>

      <main className="ps-content">
        <div className="ps-content__head">
          <div>
            <h1 className="ps-page-title">{REQUEST_KINDS[kind].title}</h1>
            <p className="ps-text ps-text--small ps-text--left">
              Escolha o formulário. Ele abre numa nova aba, no Ploomes.
            </p>
          </div>
          <input
            type="search"
            className="ps-search"
            placeholder="Buscar formulário"
            aria-label="Buscar formulário"
            value={term}
            onChange={(e) => setTerm(e.target.value)}
          />
        </div>

        {state.status === "loading" ? (
          <p className="ps-status">Carregando formulários…</p>
        ) : state.status === "error" ? (
          <p className="ps-status">
            Não foi possível carregar os formulários agora. Tente de novo em alguns minutos.
          </p>
        ) : groups.length === 0 ? (
          <p className="ps-status">
            {term ? "Nenhum formulário com esse nome." : "Nenhum formulário disponível."}
          </p>
        ) : (
          groups.map(([group, items]) => (
            <section key={group} className="ps-group" aria-label={group}>
              <h2 className="ps-group__title">{group}</h2>
              <div className="ps-grid">
                {items.map((f) => (
                  <a
                    key={f.id}
                    className="ps-form"
                    href={f.externalUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="ps-form__icon" aria-hidden="true">
                      <IconByName name={f.icon} />
                    </span>
                    <span className="ps-form__body">
                      <span className="ps-form__title">{f.title}</span>
                      {f.description ? (
                        <span className="ps-form__desc">{f.description}</span>
                      ) : null}
                    </span>
                  </a>
                ))}
              </div>
            </section>
          ))
        )}
      </main>
    </div>
  );
}
